<template>
  <v-container>
    <module-bar title="ADMINISTRAR HERRAMIENTAS" icon="mdi-tooltip-edit" />
    <v-card outlined v-if="schema != 'dash'">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field label="Nombre" v-model="params" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" :loading="loadingSearch" @click="search">buscar</v-btn>
      </v-card-actions>
    </v-card>

    <v-row class="mt-5" v-if="loadingSearch">
      <v-col cols="12" class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="2" size="60" />
      </v-col>
    </v-row>

    <v-card outlined class="mt-10" v-if="tools.length > 0">
      <v-card-text>
        <div>
          ({{ tools.length }})
          {{ tools.length == 1 ? " item encontrado" : " items encontrados" }}
        </div>
        <v-list>
          <v-list-item-group color="primary">
            <template v-for="(item, key) in tools">
              <v-list-item :key="key" v-if="tools" @click="openDialogTool(key)">
                <v-list-item-content>
                  <v-list-item-title>
                    <b> {{ item.name }}</b>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.description }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon :color="item.employee_id == 0 ? `green` : `red`">mdi-circle</v-icon>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`key${key}`" v-if="key != tools.length - 1" />
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogTool" persistent width="800">
      <v-card>
        <v-card-text>
          <tool-form
            schema="edit"
            :tool="tool"
            :click="click"
            title="EDITAR HERRAMIENTA"
            @closeDialogTool="closeDialogTool"
            @desvinculeEmployee="desvinculeEmployee"
            @vinculeEmployee="vinculeEmployee"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ToolForm from "../../components/Forms/ToolForm.vue";
import ModuleBar from "../../components/General/ModuleBar.vue";

export default {
  components: { ModuleBar, ToolForm },

  props: ["schema", "click_tool"],

  mounted() {
    if (this.schema == "dash") this.searchDash();
  },

  data() {
    return {
      dialogTool: false,
      click: 0,
      tools: [],
      tool: {},
      params: "",
      loadingSearch: false,
    };
  },

  watch: {
    click_tool() {
      this.searchDash();
    },
  },

  methods: {
    search() {
      this.loadingSearch = true;
      this.items = [];
      setTimeout(() => {
        let payload = {
          params: this.params,
        };

        this.$store
          .dispatch("findToolsParamsAction", payload)
          .then((res) => {
            this.tools = res;
            this.loadingSearch = false;
          })
          .catch(() => {
            this.loadingSearch = false;
          });
      }, 500);
    },

    openDialogTool(key) {
      this.click++;
      this.tool = this.tools[key];
      this.dialogTool = true;
    },

    closeDialogTool(data) {
      this.dialogTool = false;
      if (data) {
        let index = this.tools.findIndex((v) => v.id == data.id);
        this.tools.splice(index, 1, data);
      }
    },

    searchDash() {
      this.tools = [];
      this.loadingSearch = true;
      this.items = [];
      setTimeout(() => {
        let payload = {
          params: this.params,
        };

        this.$store
          .dispatch("findToolsParamsDashAction", payload)
          .then((res) => {
            this.tools = res;
            this.loadingSearch = false;
          })
          .catch(() => {
            this.loadingSearch = false;
          });
      }, 500);
    },

    desvinculeEmployee({toolId}) {
      let index = this.tools.findIndex((v) => v.id == toolId);
      if (index > -1) {
        this.tools[index].employee_id = 0;
      }
    },

    vinculeEmployee(data) {
      let index = this.tools.findIndex(
        (v) => v.id == parseInt(data.tool_id)
      );

      if (index > -1) {
        this.tools[index].employee = data.employee;
        this.tools[index].employee_id = data.employee.id;
      }
    },
  },
};
</script>

<style></style>
